import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import {
  ApiController,
  ApiExecutor,
  ApiResponse,
  ApiValidationService,
  Body,
  POST,
  ReportProgress,
} from '@app/core/api';
import { UploadFileResult } from '@app/core/types/upload-file-result.interface';

@ApiController('api/app/file')
@Injectable({
  providedIn: 'root',
})
export class FileApiService {
  constructor(
    public apiExecutor: ApiExecutor,
    public apiValidationService: ApiValidationService,
  ) {}

  @POST()
  @ReportProgress()
  uploadFile(@Body() formData: FormData): Observable<ApiResponse<UploadFileResult>> {
    return {} as Observable<ApiResponse<UploadFileResult>>;
  }
}
